import { useContext, useEffect, useState } from 'react'
import AuthContext from '../Contexts/AuthContext'
import PaginatorComponent from './PaginatorComponent'
import { Panel } from 'primereact/panel'
import { useTranslation } from 'react-i18next'
import { listFollowedReligiousPlaceService } from '../Service/ReligiousPlaceService'
import { Avatar } from 'primereact/avatar'
import { Dialog } from 'primereact/dialog'
import ReligiousPlaceDetailsComponent from './ReligiousPlaceDetailsComponent'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'
import AppBodyComponent from './AppBodyComponent'

function UserHomePlacesComponent() {

    const { t } = useTranslation('user_home');
    const navigate = useNavigate()
    const {userAuth, setActiveMenu, activeMenu} = useContext(AuthContext)
    const [events, setEvents] = useState()
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(1)
    const [placeDetailsAccessKey, setPlaceDetailsAccessKey] = useState()
    const [isDialogVisible, setIsDialogVisible] = useState(false)

    useEffect(()=>{
        setActiveMenu(2)
    },[])

    useEffect(()=>{
        listPlaces()
    },[page])

    const listPlaces = () =>{
        userAuth?.user?.access_key && listFollowedReligiousPlaceService(userAuth?.user?.access_key, page).then(res=>{
            setEvents(res.rows)
            setTotal(res.pages)
        })
    }

    const handlePlaceClick = (access_key) => {
        setPlaceDetailsAccessKey(access_key)
        setIsDialogVisible(true)
    }

    return (
        <AppBodyComponent>
        <div className='flex flex-column gap-2 w-full'>
            <div className='flex justify-content-between align-items-center'>
                <div className='font-bold text-xl'>{t('user_home_place_page_title')}</div>
                <Button label={t('user_home_place_page_search_button')} icon='pi pi-search' onClick={()=>navigate('/app/place_list')} />
            </div>
            {events && events.length > 0 ? 
            <div className='flex flex-column gap-2'>
                {events.map((item, key)=>(
                    <Panel key={key} className='flex flex-column gap-2 cursor-pointer' onClick={()=>handlePlaceClick(item.access_key)}>
                        <div className='flex gap-2 align-items-center'>
                            <Avatar image={`https://storage.cloud.google.com/religious_place_images/${item.picture_url}?authuser=4`} />
                            <span>{item.name}</span>
                        </div>
                        <div className='text-sm flex gap-1'>
                            <span className='font-bold'>{t('user_home_event_address')}: </span>
                            <a
                                href={`https://www.google.com/maps/search/?api=1&query=${item.address}`}
                                target='_blank'
                                rel='noopener noreferrer'
                                onClick={(e) => e.stopPropagation()}
                            >
                                {item.address}
                            </a>
                        </div>
                        <div className='text-sm'>
                            {item.description.length >= 30 ? item.description.substring(0, 30)+' ...' : item.description}
                        </div>
                        {item.going && <div className='font-bold text-green-400 mt-2'>
                            {t('user_home_event_going')}
                        </div>}
                    </Panel>
                ))}
                <PaginatorComponent page={page} setPage={setPage} total={total} />
            </div> :
            <div className='flex flex-column gap-4 align-items-center mt-4'>
                <div className='text-xl font-bold text-center'>{t('user_home_noplace_title')}</div>    
                <div className='text-center'>{t('user_home_noplace_message')}</div>    
                <Button className='w-max' label={t('user_home_noplace_button')} onClick={()=>navigate('/app/place_list')} />
            </div>}





            <Dialog visible={isDialogVisible} header maximized onHide={()=>setIsDialogVisible(false)}>
                <ReligiousPlaceDetailsComponent access_key={placeDetailsAccessKey} />
            </Dialog>
        </div>
        </AppBodyComponent>
    )
}

export default UserHomePlacesComponent